import { Assets } from "assets/Assets";
import React from "react";
import styled from "styled-components/macro";
import { device, toRem } from "theme/Breakpoints";
import { DefaultText, shadow } from "theme/GlobalElements";

interface WhoAreWeProps {}

const WhoAreWe: React.FC<WhoAreWeProps> = ({}) => {
  return (
    <WhoAreWeContainer>
      <ImageContainer>
        <StoreImage
          src={Assets.About.storePlovdiv}
          alt="Plovdiv iclima store"
        />
      </ImageContainer>
      <h3>Кои сме ние?</h3>
      <Text className="text-body">
        "И КЛИМА" ЕООД е тясно специализирана в областта на климатичната
        техника. От създаването на фирмата през 2001 година до ден днешен
        основни приоритети винаги са били високото качество и доволните клиенти.
        Нашето мото е “всеки клиент ни е важен”, за това правим всичко възможно
        да удовлетворим нуждите на клиентите ни и да се грижим за техния комфорт
        през цялата година.
        <br />
        <br />
        “И КЛИМА” осъществява дейността си чрез компетентни търговски
        консултанти, професионални монтажни и сервизни групи. Нашата политика е
        да предлагаме японски марки, както и доказали се през годините китайски
        производители. Гамата ни от продукти и производители е много голяма и
        обхваща водещи компании като Mitsubishi Electric, Mitsubishi Heavy,
        Daikin, Fuji Electric, Fujitsu, Fujitsu General, Toshiba, Gree, LG и
        други. Това, което ни отличава от конкуренцията е предлагането на нови и
        рециклирани японски хиперинвертори, перфектното изпълнение на монтажа и
        гаранционната и извънгаранционна поддръжка. При нас ще намерите климатик
        както за дома така и за вашия бизнес.
      </Text>
    </WhoAreWeContainer>
  );
};

const WhoAreWeContainer = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  padding: 0 10px;

  @media only screen and (${device.laptop}) {
    display: block;
    padding: 0 20px;
  }
`;

const ImageContainer = styled.div`
  @media only screen and (${device.laptop}) {
    margin: 0 20px 10px 0;
    width: 40%;
  }
`;

const SectionTitle = styled.p``;

const StoreImage = styled.img`
  width: 100%;
  height: 100%;
  ${shadow}
`;

const Text = styled(DefaultText)``;

export default WhoAreWe;
